'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('services.esbEmployees', [])

.factory('esbEmployeeService', ['$http', '$q', function ($http, $q) {
    var baseUrl = environment.apiUrl + '/Pilot/api/ESB/Employee';

    var service = {};

    // Search ESB Employees
    service.searchEmployees = function (searchTerm) {
        return $http
            .get(baseUrl + '/' + searchTerm, { cache: true })
            .then(function (response) {return response.data;});
    };

    // Search ESB Employees for sending emails
    service.searchEmployeesForSendEmail = function (searchTerm) {
        return $http
            .get(baseUrl + '/For/Send/Email/' + searchTerm, { cache: true })
            .then(function (response) {return response.data;});
    };

    return service;
}]);
